
import type { Dayjs } from 'dayjs';
import React, { useState } from 'react';

import { Box, MenuItem, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

interface EndOfLeaseProps {
  onChange: (data: { endOfLeaseType: string; effectiveDate: string | null }) => void;
}

const EndOfLease: React.FC<EndOfLeaseProps> = ({ onChange }) => {
  const [endOfLeaseType, setEndOfLeaseType] = useState('Renewal');
  const [effectiveDate, setEffectiveDate] = useState<Dayjs | null>(dayjs());

  React.useEffect(() => {
    onChange({
      endOfLeaseType,
      effectiveDate: effectiveDate ? effectiveDate.format('YYYY-MM-DD') : null
    });
  }, [endOfLeaseType, effectiveDate]);

  return (
    <Box sx={{ width: "50%" }}>
      <TextField
        select
        label="End-of-Lease Type"
        value={endOfLeaseType}
        onChange={e => setEndOfLeaseType(e.target.value)}
        margin="normal"
        fullWidth
        data-testid="asset-end-of-lease-type-select"
      >
        <MenuItem value="Renewal" data-testid="asset-end-of-lease-type-renewal">Renewal</MenuItem>
        <MenuItem value="Buy-out" data-testid="asset-end-of-lease-type-buyout">Buy-out</MenuItem>
        <MenuItem value="Return" data-testid="asset-end-of-lease-type-return">Return</MenuItem>
      </TextField>
      <DatePicker
        label="Effective Date"
        value={effectiveDate}
        onChange={setEffectiveDate}
        slotProps={{ textField: { fullWidth: true, size: 'medium', margin: 'normal', focused: true, inputProps: {'data-testid':'asset-end-of-lease-effective-date-picker'}} }}
      />
    </Box>
  );
};

export default EndOfLease;
